export const environment = {
  production: true,
  host: 'http://localhost:4200/it',
  redirect_host: 'http://localhost:4200/it/circuits/'
};
